/**
 * Function used to get a property out of the properties of a Feature
 *
 * @param propertyKey
 * @returns
 */
export const getProperty = (propertyKey: string): unknown[] => [
  'get',
  propertyKey,
]

/**
 * Function used to set the values when querying.  The value can
 * be an array or a single value
 *
 * @param v - value to query
 * @returns
 */
export const values = (v: unknown): unknown => {
  return v && Array.isArray(v) ? ['literal', v] : v
}

/**
 * Function for a greater than or equals to expression
 * Note - this casts the property to a number
 *
 * @param field - The feature property key to filter against
 * @param val
 * @returns
 */
export const greaterThanOrEquals = (field: string, val: unknown): unknown[] => [
  '>=',
  ['to-number', getProperty(field)],
  val,
]

/**
 * Function for a less than or equals to expression
 * Note - this casts the property to a number
 *
 * @param field - The feature property key to filter against
 * @param val
 * @returns
 */
export const lessThanOrEquals = (field: string, val: unknown): unknown[] => [
  '<=',
  ['to-number', getProperty(field)],
  val,
]

/**
 * Function for a greater than expression
 *
 * @param field - The feature property key to filter against
 * @param val
 * @returns
 */
export const greaterThan = (field: string, val: unknown): unknown[] => [
  '>',
  ['to-number', getProperty(field)],
  val,
]
/**
 * Function for a less than expression
 *
 * @param field - The feature property key to filter against
 * @param val
 * @returns
 */
export const lessThan = (field: string, val: unknown): unknown[] => [
  '<',
  ['to-number', getProperty(field)],
  val,
]

/**
 * Function for an equals expression
 *
 * @param field - The feature property key to filter against
 * @param val
 * @returns
 */
export const equalsExpression = (field: string, val: unknown): unknown[] => [
  '==',
  getProperty(field),
  val,
]

/**
 * Function for a not equals expression
 *
 * @param field - The feature property key to filter against
 * @param val
 * @returns
 */
export const notEqual = (field: string, val: unknown): unknown[] => [
  '!=',
  getProperty(field),
  val,
]

/**
 * Function for an in expression
 *
 * @param v
 * @param field - The feature property key to filter against
 * @returns
 */
export const inExpression = (v: unknown, field: string): unknown[] => [
  'in',
  v,
  getProperty(field),
]

/**
 * Function for an all expression
 *
 * @param args
 * @returns
 */
export const all = (...args: unknown[]): unknown[] => ['all', ...args]

/**
 * Function for an any expression
 *
 * @param args
 * @returns
 */
export const any = (...args: unknown[]): unknown[] => ['any', ...args]

/**
 * Function for a has expression
 *
 * @param args
 * @returns
 */
export const has = (...args: unknown[]): unknown[] => ['has', ...args]

/**
 * Function for a not expression
 *
 * @param args
 * @returns
 */
export const not = (...args: unknown[]): unknown[] => ['!', ...args]
